import { render, staticRenderFns } from "./StackedPlot.vue?vue&type=template&id=08172856&"
import script from "./StackedPlot.vue?vue&type=script&lang=js&"
export * from "./StackedPlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports